import sha256 from 'js-sha256';
import { nanoid } from 'nanoid';

export const generateCodeChallenge = (codeVerifier) =>
{
  const hashedCodeVerifier = sha256.arrayBuffer(codeVerifier);
  const base64UrlEncoded = base64urlencode(hashedCodeVerifier);
  return base64UrlEncoded;
};

export const generateCodeVerifier = () =>
{
  const codeVerifier = nanoid(128);
  return codeVerifier;
};

const base64urlencode = (arrayBuffer) => {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  const base64 = btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
  return base64.substring(0, base64.indexOf('=') === -1 ? base64.length : base64.indexOf('='));
};
